import axios from "axios";

const bounties = [
  {
    location: { _latitude: 34.04026, _longitude: -118.437909 },
    title: "Sepulveda & Olympic",
    image:
      "https://firebasestorage.googleapis.com/v0/b/trashero.appspot.com/o/litterbin.jpg?alt=media&token=9463b11a-200a-430e-a81f-555fc1b1ae51",
    reporter: { username: "tester123", id: "wSboeRqBVwWM2rvZpJy7" },
    reward: "2",
    id: "4dU6tCAjp0c3O8MgrQ8h"
  },
  {
    reporter: { username: "fishorange", id: "MzD5kfsJg7Jp0TVHvkXW" },
    reward: "12",
    location: { _latitude: 33.7668655, _longitude: -117.9261585 },
    title: "d",
    image:
      "https://storage.googleapis.com/trashero.appspot.com/460123422908bfebf39382ac304ed604.png",
    id: "CHMCbVVyxIq8SGP6EUPP"
  },
  {
    reporter: { username: "fishorange", id: "MzD5kfsJg7Jp0TVHvkXW" },
    bounty: "30",
    location: { _latitude: 38.9860185, _longitude: -76.93893 },
    title: "Mr Khuongs",
    image:
      "https://storage.googleapis.com/trashero.appspot.com/15540532270605889217232765061565.jpg",
    id: "MEMJ8AWfIayaWjgjG1Qe"
  },
  {
    location: { _latitude: 33.7669157, _longitude: -117.9258494 },
    title: "mocktest",
    image:
      "https://storage.googleapis.com/trashero.appspot.com/1547065279881.jpg",
    reporter: { username: "sandra.actor", id: "96320454" },
    reward: "50",
    id: "S2wJcVMP4KfDMob4ucvM"
  },
  {
    reporter: { username: "realman", id: "vNDFfyqMw5bn8nllXejN" },
    bounty: "12",
    location: { _latitude: 38.9860185, _longitude: -76.93893 },
    title: "Hard Working Gentleman",
    image:
      "https://storage.googleapis.com/trashero.appspot.com/15540533029124123216362523650903.jpg",
    id: "ZBoCRPWHY5zwQjzxj7Cp"
  },
  {
    reporter: { username: "redbaker", id: "USUoJ7pHCUiQ8AnIGHAm" },
    reward: 1,
    location: { _latitude: 34.056308, _longitude: -118.434783 },
    title: "Manning & Wilkins",
    image:
      "https://firebasestorage.googleapis.com/v0/b/trashero.appspot.com/o/Student-1st-Place-Winner-2016-Nature-is-no-Cup-Holder.jpg?alt=media&token=499ef3a7-047e-476a-89a0-8b14cf6a1a74",
    id: "ZcCSU8LvCxE20BXUua1w"
  },
  {
    location: { _latitude: 33.831662, _longitude: -118.272361 },
    title: "Dolores & Carson",
    image:
      "https://firebasestorage.googleapis.com/v0/b/trashero.appspot.com/o/litter-at-bus-stop-472x354.png?alt=media&token=d6d1f309-07f4-4643-a9f4-81dfe371f453",
    reporter: { username: "realman", id: "vNDFfyqMw5bn8nllXejN" },
    reward: "2",
    id: "axSOXT5NS4wEZ7MSChyM"
  },
  {
    reporter: { username: "testuser123", id: "wSboeRqBVwWM2rvZpJy7" },
    reward: 20,
    location: { _latitude: 33.745126, _longitude: -117.9201 },
    title: "Harbor & 1st",
    image:
      "https://firebasestorage.googleapis.com/v0/b/trashero.appspot.com/o/6359342235454319331708900232_1644839-orig.jpg?alt=media&token=9d509653-7dc8-4cec-8db1-66bf20d7b242",
    id: "fRZWQnVShkhgumfJVIa4"
  },
  {
    location: { _latitude: 34.054146, _longitude: -118.440736 },
    title: "Ohio & Westwood",
    image:
      "https://firebasestorage.googleapis.com/v0/b/trashero.appspot.com/o/Litter-Bugs.jpg?alt=media&token=a9f0ab3f-6cae-41ce-bc13-f1f152261e16",
    reporter: { username: "hunter12", id: "Rjy6f83zPELLTtWk7gbP" },
    reward: "4",
    id: "lsN8XYSlHeykp99yXUaj"
  },
  {
    reporter: { reporter: "hunter12", id: "Rjy6f83zPELLTtWk7gbP" },
    bounty: "5",
    location: {
      _latitude: 33.768006150793084,
      _longitude: -117.92544783565893
    },
    title: "Tester",
    image: "https://storage.googleapis.com/trashero.appspot.com/image.jpg",
    id: "q2sOJg6JwrPtrcAzyyiq"
  },
  {
    reporter: { username: "redbaker", id: "USUoJ7pHCUiQ8AnIGHAm" },
    bounty: "30",
    location: { _latitude: 33.76798176139359, _longitude: -117.9255827787191 },
    title: "Hello",
    image: "https://storage.googleapis.com/trashero.appspot.com/image.jpg",
    id: "vE7GSSJJaDDlrZhR8jxV"
  },
  {
    bounty: "5",
    image:
      "https://storage.googleapis.com/trashero.appspot.com/Baby-Shark-Cupcake-Toppers-Baby.png",
    latitude: "34.0648",
    longitude: "-118.4414",
    reporter: { username: "buggyjun", id: "meRCNhso21lLM0vTOcTM" },
    title: "YOYOY",
    id: "yIPrUyr0R45KnCJls08i"
  }
];

export const getAllBounties = async mock => {
  if (mock) {
    return { data: bounties, status: 200 };
  } else {
    try {
      const response = await axios.get("https://api.trashero.net/bounty");

      if (response.status === 200) {
        return response;
      }
    } catch (err) {
      return {
        status: 500,
        error: err
      };
    }
  }
};

export const getBounty = async (mock, id) => {
  if (mock) {
    return { data: bounties[0], status: 200 };
  } else {
    try {
      const response = await axios.get(`https://api.trashero.net/bounty/${id}`);

      if (response.status === 200) {
        return response;
      }
    } catch (err) {
      return {
        status: 500,
        error: err
      };
    }
  }
};

export const postBounty = async mock => {
  if (mock) {
    return { status: 200 };
  } else {
    return { status: 200 };
  }
};
